// Clean, printable PDF blueprint via a styled print window
import type { ShredResults } from './shred'
import type { Meal } from './plans'

export function exportBlueprint(r: ShredResults, meals: Meal[]) {
  const win = window.open('', '_blank', 'width=820,height=1000')
  if (!win) return

  const mealRows = meals
    .map(
      (m) => `
      <tr>
        <td><strong>${m.name}</strong><br/><span class="muted">${m.items.join(' · ')}</span></td>
        <td class="num">${m.calories} kcal</td>
        <td class="num">${m.protein}g</td>
      </tr>`
    )
    .join('')

  const ffmiRow =
    r.ffmi != null
      ? `<div class="stat"><span>FFMI (Muscularity)</span><b>${r.ffmi} — ${r.ffmiClass}</b></div>`
      : ''

  const html = `<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<title>Shred Calculator — Daily Blueprint</title>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Helvetica Neue', Arial, sans-serif; color: #0a0c10; padding: 48px; line-height: 1.5; }
  .brand { display:flex; align-items:center; gap:10px; margin-bottom: 4px; }
  .dot { width:14px; height:14px; border-radius:4px; background:#3b82f6; }
  h1 { font-size: 26px; letter-spacing:-0.5px; }
  .sub { color:#5b6472; font-size: 13px; margin-bottom: 28px; }
  .hero { background:#0a0c10; color:#fff; border-radius:16px; padding:28px; margin-bottom:24px; display:flex; justify-content:space-between; align-items:center; }
  .hero .big { font-size: 44px; font-weight: 700; }
  .hero .label { font-size:12px; text-transform:uppercase; letter-spacing:1px; color:#8b96a8; }
  .grid { display:grid; grid-template-columns: repeat(3,1fr); gap:14px; margin-bottom:24px; }
  .stat { border:1px solid #e2e6ee; border-radius:12px; padding:16px; }
  .stat span { display:block; font-size:11px; text-transform:uppercase; letter-spacing:0.5px; color:#5b6472; margin-bottom:6px;}
  .stat b { font-size: 20px; }
  h2 { font-size: 16px; margin: 24px 0 12px; }
  table { width:100%; border-collapse: collapse; }
  td { padding:12px; border-bottom:1px solid #e2e6ee; font-size:13px; vertical-align: top;}
  .num { text-align:right; white-space:nowrap; font-variant-numeric: tabular-nums; }
  .muted { color:#5b6472; font-size:11px; }
  .footer { margin-top:32px; font-size:11px; color:#8b96a8; text-align:center; }
  @media print { body { padding: 24px; } }
</style>
</head>
<body>
  <div class="brand"><div class="dot"></div><strong>ShredCalculator.com</strong></div>
  <h1>Your Daily Shred Blueprint</h1>
  <div class="sub">Science-backed plan to get a ripped body · Formula: ${r.formula}</div>

  <div class="hero">
    <div>
      <div class="label">Daily Calorie Target</div>
      <div class="big">${r.dailyCalories.toLocaleString()} kcal</div>
    </div>
    <div style="text-align:right">
      <div class="label">Active Deficit</div>
      <div class="big">${r.deficitPct}%</div>
    </div>
  </div>

  <div class="grid">
    <div class="stat"><span>BMR</span><b>${r.bmr.toLocaleString()} kcal</b></div>
    <div class="stat"><span>TDEE</span><b>${r.tdee.toLocaleString()} kcal</b></div>
    <div class="stat"><span>Protein</span><b>${r.protein}g</b></div>
    <div class="stat"><span>Carbs</span><b>${r.carbs}g</b></div>
    <div class="stat"><span>Fats</span><b>${r.fats}g</b></div>
    <div class="stat"><span>Water</span><b>${r.waterLiters}L · ${r.waterCups} cups</b></div>
  </div>

  <div class="grid">
    <div class="stat"><span>Shred Timeline</span><b>${r.weeksToLean > 0 ? r.weeksToLean + ' weeks' : 'N/A'}</b></div>
    <div class="stat"><span>Target Body Fat</span><b>${r.targetBodyFat}%</b></div>
    ${ffmiRow || '<div class="stat"><span>Lean Body Mass</span><b>' + (r.leanBodyMassLbs ? r.leanBodyMassLbs + ' lbs' : '—') + '</b></div>'}
  </div>

  <h2>Meal Blueprint — Best Meals to Get Ripped</h2>
  <table>
    <tr><td><strong>Meal</strong></td><td class="num">Calories</td><td class="num">Protein</td></tr>
    ${mealRows}
  </table>

  <div class="footer">Generated by ShredCalculator.com — Lean and ripped, the smart way. Consult a professional before major diet changes.</div>

  <script>
    window.onload = function() { window.focus(); window.print(); };
  </script>
</body>
</html>`

  win.document.write(html)
  win.document.close()
}
